import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_DOW_DEMO_DNA1_END = {
  title:
    "Find out more about Infosys Data Operations \nWorkbench demo from our staff. ",
  bgImage: "DNA1/DNA1_intro_04.jpg",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  optionsButtons: [
    {
      label: "Overview",
      onClick: () => setCurrentPage(101),
      type: "transparent",
      startIcon: "arrow-left",
    },
    {
      label: "RESTART DEMO",
      onClick: () => setCurrentPage(105),
      endIcon: "arrow-right",
    },
  ],
};
